import { Component, OnInit, AfterViewInit } from '@angular/core';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material';
import { Router, ActivatedRoute } from '@angular/router';

import { filterUserRoles } from 'src/app/shared/utils/user.util';
import { ProfileService, LocalService, StoreService, SellerService, DashboardService } from '../../core';
import { PopupMessageService } from '../../shared/message/services/message.service';
import { CONSTANTS } from '../../config';


@Component({
  selector: 'app-basic-info',
  templateUrl: './basic-info.component.html',
  styleUrls: ['./basic-info.component.scss'],
})
export class BasicInfoComponent implements OnInit, AfterViewInit {

  years = CONSTANTS.years;
  userProfile: any;
  selectedFile!: File;
  countryFlag = false;
  userInfoForm!: FormGroup;
  roleList: any[] = [];
  agreeFlag = false;
  currentPic: any;
  selfServiceUrl = 'https://www.cisco.com/go/pss';
  firstAdmin = false;
  adminInfoForm!: FormGroup;
  allCompanyFullName: any[] = [];
  disableButton = false;
  redeemFlag = false;
  isTaxFormMandate = false;
  selectedLanguage!: string;
  updateTaxUsers = [
    'activatedco', 'bslapak@convergeone.com', 'eshannon@chickasawtel.com',
    'geruiznxp', 'harrisonmilanian6760', 'kspotts52', 'mpeterson@compunet.biz',
    'rebeccab123', 'sandesh', 'scasey112689', 'StylesBaker5780', 'teri.anderson', 'thomas.surber',
  ];
  isTaxUpdatFlag = false;
  pamUserForm!: FormGroup;
  pamAgreeFlag = false;
  progmMgrNm = '';

  options: any[] = [];
  countryItems: any[] = [];
  regionsList: any[] = [];

  beGeoIDoptions: any[] = [];
  beGeoItems: any[] = [];
  beGeoPage: number = 0;
  beGeoTotalElements: number = 0;
  beGeoLoading: boolean = false;
  currentCountryForBeGeo: string = '';
  userProfileData: any;

  rolesDescriptionOpen = false;
  updateModalOpen = false;
  usaFormModalOpen = false;
  canadaFormModalOpen = false;
  createModalOpen = false;

  private readonly programManagerConfig: Record<string, any> = {
    APJ: 'Chinnakkal Shabeer',
    GC: 'Chinnakkal Shabeer',
    AMERICAS: {
      USA: 'Jaycee Foran',
      CANADA: 'Shawnett Worrell',
      default: 'Alejandra Beauchamp',
    },
    default: 'Alejandra Beauchamp',
  };

  constructor(
    private profileService: ProfileService,
    private router: Router,
    private route: ActivatedRoute,
    private dialog: MatDialog,
    private formBuilder: FormBuilder,
    private storeService: StoreService,
    private popupMessageService: PopupMessageService,
    private sellerService: SellerService,
    private dashboardService: DashboardService,
  ) { }

  ngOnInit() {
    const lang = localStorage.getItem('selectedLanguage');
    this.selectedLanguage = localStorage.getItem('selectedLanguage') as string;

    if (lang === 'Korean') {
      this.years = CONSTANTS.korean_years;
    }
    if (lang === 'Japanese') {
      this.years = CONSTANTS.japanese_years;
    }

    this.dialog.closeAll();
    this.userInfoForm = <FormGroup>this.formBuilder.group({
      roles: ['', [Validators.required]],
      ciscoSalesExperience: ['', [Validators.required]],
      secondaryEmail: ['', [Validators.email]],
    });
    this.generateFirstAdminForm();
    this.generatePamUserForm();
    this.userProfile = LocalService.get('userProfile');
    if (!this.userProfile) {
      return;
    }
    this.userProfileData = this.userProfile.roles;
    if (this.userProfile.hasOwnProperty('userType') && this.userProfile.userType === 'PAM') {
      this.userProfile.active ? this.pamAgreeFlag = true : this.pamAgreeFlag = false;
      this.getRegionList();
    }

    if (
      (this.userProfile.grsUser && this.userProfile.active && !this.userProfile.company.profileComplete) ||
      (this.userProfile.grsUser && !this.userProfile.active && !this.userProfile.onlyRedeemPoints)
    ) {
      this.getPointsAvailable();
    }
    this.storeService.currentProfileImage.subscribe((message: any) => {
      this.currentPic = message;
    });
    if (
      this.userProfile.adminInPss &&
      !this.userProfile.company.profileComplete &&
      !this.userProfile.company.companyProfileInformationProvided
    ) {
      this.firstAdmin = true;
      this.getCompanyUsers();
      this.watchAdminFields(true);
    } else {
      this.watchAdminFields(false);
    }
    if ('country' in this.userProfile) {
      const country = this.userProfile.country ? this.userProfile.country.toLowerCase() : '';
      if (country === 'united states of america' || country === 'united states' || country === 'usa' || country === 'canada') {
        this.countryFlag = true;
      }
    }
    if (this.userProfile.taxInfo) {
      this.countryFlag = true;
    }
    this.getAllRoles();
    this.checkUpdateTaxUsers();
  }

  generatePamUserForm() {
    this.pamUserForm = <FormGroup>this.formBuilder.group({
      partnerTheatre: ['', [Validators.required]],
      partnerCountry: ['', [Validators.required]],
      partnerBeGeo: ['', [Validators.required]],
    });
  }

  onPartnerTheatreChange(selectedTheatre: any) {
    this.pamUserForm.patchValue({ partnerTheatre: selectedTheatre.name });
    this.getCountryList('region');
  }

  get selectedTheatre() {
    const theatreControl = this.pamUserForm.get('partnerTheatre');
    if (!theatreControl) { return null; }
    const value = theatreControl.value;
    return this.regionsList.find((r: any) => r.name === value);
  }

  get selectedCountry() {
    const countryControl = this.pamUserForm.get('partnerCountry');
    if (!countryControl) { return null; }
    const value = countryControl.value;
    return this.countryItems.find((c: any) => c.name === value);
  }

  onCountryChange(selectedCountry: any) {
    this.pamUserForm.patchValue({ partnerCountry: selectedCountry.name });
    this.onChangeCountry(selectedCountry.name);
  }

  get selectedBeGeo() {
    const beGeoControl = this.pamUserForm.get('partnerBeGeo');
    if (!beGeoControl) { return null; }
    const value = beGeoControl.value;
    return this.beGeoItems.find((b: any) => b.partnerNameBegeoId === value);
  }

  get isPamUser(): boolean {
    return this.userProfile && this.userProfile.hasOwnProperty('userType') && this.userProfile.userType === 'PAM';
  }

  get selectedYear() {
    const yearControl = this.userInfoForm.get('ciscoSalesExperience');
    if (!yearControl) { return null; }
    const value = yearControl.value;
    return this.years.find((y: any) => y.value === value);
  }

  onCiscoSalesExperienceChange(selectedYear: any) {
    this.userInfoForm.patchValue({ ciscoSalesExperience: selectedYear.value });
  }

  get selectedRoles(): any[] {
    const rolesControl = this.userInfoForm.get('roles');
    if (!rolesControl || !rolesControl.value) { return []; }
    const controlValues = rolesControl.value;
    return this.roleList.filter((role: any) => controlValues.some((val: any) => this.checkSelected(val, role)));
  }

  onRolesChange(selectedRoles: any[]) {
    this.userInfoForm.patchValue({ roles: selectedRoles });
  }

  get adminSelectedYear() {
    const yearControl = this.adminInfoForm.get('ciscoSalesExperience');
    if (!yearControl) { return null; }
    const value = yearControl.value;
    return this.years.find((y: any) => y.value === value);
  }

  onAdminCiscoSalesExperienceChange(selectedYear: any) {
    this.adminInfoForm.patchValue({ ciscoSalesExperience: selectedYear.value });
  }

  get adminSelectedRoles(): any[] {
    const rolesControl = this.adminInfoForm.get('roles');
    if (!rolesControl || !rolesControl.value) { return []; }
    const controlValues = rolesControl.value;
    return this.roleList.filter((role: any) => controlValues.some((val: any) => this.checkSelected(val, role)));
  }

  onAdminRolesChange(selectedRoles: any[]) {
    this.adminInfoForm.patchValue({ roles: selectedRoles });
  }

  onBeGeoChange(selectedBeGeo: any) {
    this.pamUserForm.patchValue({ partnerBeGeo: selectedBeGeo.partnerNameBegeoId });
  }

  checkUpdateTaxUsers() {
    if (this.updateTaxUsers.indexOf(this.userProfile.username) > -1) { this.isTaxUpdatFlag = true; }
  }

  getPointsAvailable() {
    this.sellerService.getPointsAvailable().subscribe((data: any) => {
      if (data.pointsRemaining) {
        this.redeemFlag = true;
      }
    }, (_err: any) => { });
  }

  generateFirstAdminForm() {
    this.adminInfoForm = <FormGroup>this.formBuilder.group({
      roles: ['', [Validators.required]],
      ciscoSalesExperience: ['', [Validators.required]],
      secondaryEmail: ['', [Validators.email]],
      salesAccountManagersCount: ['', [Validators.required, Validators.pattern(CONSTANTS.regex.numeric)]],
      salesSystemEngineersCount: ['', [Validators.required, Validators.pattern(CONSTANTS.regex.numeric)]],
      salesCountry: ['', [Validators.required, Validators.pattern(CONSTANTS.regex.alphaWithComma)]],
      programAdministrators: ['', [Validators.required]],
      programSalesManagers: ['', [Validators.required]],
      programSEManagers: ['', [Validators.required]],
    });
  }

  ngAfterViewInit() {
    window.scrollTo(0, 0);
  }

  watchAdminFields(adminFlag: boolean) {
    if (adminFlag) {
      (this.adminInfoForm.get('roles') as any).valueChanges.subscribe((value: any) => {
        if (value && value.length) {
          const names = value.map((item: any) => item.name);
          this.isTaxFormMandate = (
            (value.length === 1 && names.includes('PRACTICE_MANAGER')) ||
            (value.length === 1 && names.includes('COMPANY_ADMIN')) ||
            (value.length === 2 && names.includes('PRACTICE_MANAGER') && names.includes('COMPANY_ADMIN'))
          );
        }
      });
    } else {
      (this.userInfoForm.get('roles') as any).valueChanges.subscribe((value: any) => {
        if (value && value.length) {
          const names = value.map((item: any) => item.name);
          this.isTaxFormMandate = (
            (value.length === 1 && names.includes('PRACTICE_MANAGER')) ||
            (value.length === 1 && names.includes('COMPANY_ADMIN')) ||
            (value.length === 2 && names.includes('PRACTICE_MANAGER') && names.includes('COMPANY_ADMIN'))
          );
        }
      });
    }
  }

  checkPendingApproval(roleName: string) {
    if (this.userProfile.pendingRoles && this.userProfile.pendingRoles.length) {
      return this.userProfile.pendingRoles.find((item: any) => item.name === roleName);
    }
    return undefined;
  }

  getAllRoles() {
    this.profileService.getAllRoles().subscribe((data: any) => {
      if (data) {
        this.roleList = data;
        if (this.userProfile.adminInPss) {
          const managerRoles = CONSTANTS.manager;
          const sellerRoles = CONSTANTS.seller;
          this.roleList.map((obj: any) => {
            obj.isDisabled = managerRoles.includes(obj.name) || sellerRoles.includes(obj.name);
            if (this.checkPendingApproval(obj.name)) {
              obj.isPendingApproval = true;
              obj.isDisabled = false;
            } else {
              obj.isPendingApproval = false;
            }
          });
          const lang = localStorage.getItem('selectedLanguage');
          if (lang === 'Korean' || lang === 'Japanese') {
            Object.keys(this.roleList).forEach((key: any) => {
              const role = (this.roleList as any)[key];
              if (role['description'] === 'Individual Contributor (Sales: Account Manager)') {
                role['description'] = (lang === 'Korean')
                  ? '개인 기여자 (판매: 계정 매니저)'
                  : '社員 - セールスアカウントマネージャ';
              }
              if (role['description'] === 'Individual Contributor (Sales: Sales/System Engineers)') {
                role['description'] = (lang === 'Korean')
                  ? '개인 기여자 (판매 :판매/시스템 엔지니어)'
                  : '社員 - セールスSE';
              }
              if (role['description'] === 'Management (Sales Manager)') {
                role['description'] = (lang === 'Korean') ? '관리 (판매 매니저)' : '管理 (セールスマネージャ)';
              }
              if (role['description'] === 'Cisco Practice Lead') {
                role['description'] = (lang === 'Korean') ? 'Cisco 실행 리드' : 'シスコプラクティスリード';
              }
              if (role['description'] === 'Administrator') {
                role['description'] = (lang === 'Korean') ? '관리자' : '管理者';
              }
              if (role['description'] === 'Management (System Engineers Manager)') {
                role['description'] = (lang === 'Korean') ? '관리 (시스템 엔지니어 매니저)' : '管理 (SEマネージャ)';
              }
            });
          }
          if (this.userProfile.roles && this.userProfile.roles.length) {
            this.userProfile.roles = this.userProfile.roles.filter((item: any) =>
              managerRoles.includes(item.name) || sellerRoles.includes(item.name)
            );
          }
        } else {
          const managerRoles = CONSTANTS.manager;
          const sellerRoles = CONSTANTS.seller;
          this.roleList.map((obj: any) => {
            obj.isDisabled = sellerRoles.includes(obj.name);
            if (obj.name === 'SALES_MANAGER') {
              obj.isDisabled = true;
            }
            if (this.checkPendingApproval(obj.name)) {
              obj.isPendingApproval = true;
              obj.isDisabled = false;
            } else {
              obj.isPendingApproval = false;
            }
          });
          if (this.userProfile.roles && this.userProfile.roles.length) {
            this.userProfile.roles = this.userProfile.roles.filter((item: any) =>
              managerRoles.includes(item.name) || sellerRoles.includes(item.name)
            );
          }
        }
        if (this.firstAdmin) {
          this.adminInfoForm.patchValue(this.userProfile, { onlySelf: true });
        } else {
          this.userInfoForm.patchValue(this.userProfile, { onlySelf: true });
        }
      }
    }, (_err: any) => { });
  }

  getCompanyUsers() {
    const companyId = this.userProfile.company.id;
    this.profileService.companyAllUsers(companyId).subscribe((data: any) => {
      if (data) {
        this.allCompanyFullName = data.map((obj: any) => {
          obj.fullName = obj.firstName + ' ' + obj.lastName + ' (' + obj.username + ')';
          return obj;
        });
      }
      this.allCompanyFullName.push({
        id: this.userProfile.id,
        firstName: this.userProfile.firstName,
        lastName: this.userProfile.lastName,
        username: this.userProfile.username,
        fullName: `${this.userProfile.firstName} ${this.userProfile.lastName} (${this.userProfile.username})`,
        profilePicUrl: this.userProfile.profilePicUrl,
      });
    }, (_err: any) => { });
  }

  onFileChanged(event: any) {
    this.selectedFile = event.target.files[0];
    const reader = new FileReader();
    reader.onloadend = () => {
      const dataUrl = reader.result as string;
      this.userProfile.profilePicUrl = dataUrl;
      this.storeService.changeProfileImage(dataUrl);
      if (this.userProfile.id) {
        this.uploadProfilePic();
      }
    };
    if (this.selectedFile) {
      reader.readAsDataURL(this.selectedFile);
    }
  }

  openDescription() {
    this.rolesDescriptionOpen = true;
  }

  closeRolesDescription() {
    this.rolesDescriptionOpen = false;
  }

  closeUpdateModal() {
    this.updateModalOpen = false;
    this.navigateUser(this.userProfile);
  }

  closeUsaFormModal() {
    this.usaFormModalOpen = false;
  }

  closeCanadaFormModal() {
    this.canadaFormModalOpen = false;
  }

  closeCreateModal() {
    this.createModalOpen = false;
    this.navigateUser(this.userProfile);
  }

  uploadProfilePic() {
    const uploadData = new FormData();
    uploadData.append('profilePic', this.selectedFile, this.selectedFile.name);
    this.profileService.postProfilePic(uploadData, this.userProfile.id)
      .subscribe((data: any) => {
        this.userProfile.profilePicUrl = data.profilePicUrl;
        LocalService.set('userProfile', this.userProfile);
      });
  }

  navigateUser(userData: any) {
    if (userData.active && userData.company.profileComplete) {
      const managerFlag = filterUserRoles(userData, CONSTANTS.manager).length > 0;
      const sellerFlag = filterUserRoles(userData, CONSTANTS.seller).length > 0;
      if (managerFlag) {
        return this.router.navigateByUrl('/home/manager/manage-challenges');
      }
      if (sellerFlag) {
        return this.router.navigateByUrl('/home/seller/challenges');
      }
    } else if (userData.adminInPss && !userData.company.profileComplete) {
      return;
    }
    return this.router.navigateByUrl('/home');
  }

  updateProfile(taxInfoFlag: boolean) {
    LocalService.set('userProfile', { ...this.userProfile, ...this.userInfoForm.value });
    this.userProfile = LocalService.get('userProfile');
    if (!taxInfoFlag) {
      if (this.userProfile.taxInfo) {
        (this.userProfile.taxInfo.type === 'W9' || this.userProfile.taxInfo.type === 'W8BEN')
          ? this.router.navigate(['./tax-infow9'], { relativeTo: this.route })
          : this.router.navigate(['./tax-infot4'], { relativeTo: this.route });
      } else {
        const country = this.userProfile.country.toLowerCase();
        country === 'united states of america' || country === 'united states' || country === 'usa'
          ? this.router.navigate(['./tax-infow9'], { relativeTo: this.route })
          : this.router.navigate(['./tax-infot4'], { relativeTo: this.route });
      }
      return;
    }
    if (!this.userProfile.taxInfo && this.countryFlag
      && !this.isTaxFormMandate && (this.updateTaxUsers.indexOf(this.userProfile.username) > -1)) {
      const country = this.userProfile.country.toLowerCase();
      if (country === 'united states of america' || country === 'united states' || country === 'usa') {
        this.usaFormModalOpen = true;
      }
      if (this.userProfile.country.toLowerCase() === 'canada') {
        this.canadaFormModalOpen = true;
      }
      return;
    } else {
      this.disableButton = true;
      delete this.userProfile.profilePicUrl;

      if (this.userProfile.id) {
        LocalService.set('userProfile', this.userProfile);
        if (this.userProfile.pendingRoles && this.userProfile.pendingRoles.length) {
          this.userProfile.roles = [...this.userProfile.roles, ...this.userProfile.pendingRoles];
        }
        if (this.userProfileData) {
          this.userProfileData.forEach((element: any) => {
            if (element.id === 6) {
              this.userProfile.roles.push(
                { createdBy: null, modifiedBy: null, id: 6, name: 'SUPER_ADMIN', description: 'Super Administrator' });
            } else if (element.id === 8) {
              this.userProfile.roles.push(
                { createdBy: null, modifiedBy: null, id: 8, name: 'COMPANY_AS_A_USER', description: 'Company as a user' });
            } else if (element.id === 11) {
              this.userProfile.roles.push(
                { createdBy: null, description: 'Activity Challenge Approver', id: 11, modifiedBy: null, name: 'AC_APPROVER' });
            } else if (element.id === 10) {
              this.userProfile.roles.push(
                { createdBy: null, modifiedBy: null, id: 10, name: 'CISCO_ADMIN', description: 'Cisco Administrator' });
            }
          });
        }
        const seenIds = new Set();
        this.userProfile.roles = this.userProfile.roles
          .filter((role: any) => {
            if (seenIds.has(role.id)) return false;
            seenIds.add(role.id);
            return true;
          })
          .map((role: any) => ({ id: role.id, name: role.name, description: role.description, createdBy: role.createdBy || null, modifiedBy: role.modifiedBy || null }));
        this.profileService.updateProfile(this.userProfile).subscribe((data:any) => {
          this.disableButton = false;
          LocalService.set('userProfile', data);
          this.userProfile = LocalService.get('userProfile');
          this.storeService.updateRole.next(true);
          this.updateModalOpen = true;
        }, (_err: any) => { });
      } else {
        LocalService.set('userProfile', this.userProfile);
        this.profileService.postProfile(this.userProfile).subscribe((data: any) => {
          LocalService.set('userProfile', data);
          this.userProfile = LocalService.get('userProfile');
          if (this.currentPic) {
            this.profileService.postProfilePic(this.currentPic, this.userProfile.id)
              .subscribe((pic: any) => {
                this.disableButton = false;
                this.userProfile.profilePicUrl = pic.profilePicUrl;
                LocalService.set('userProfile', this.userProfile);
                this.createModalOpen = true;
              }, (_err: any) => { });
          } else {
            this.createModalOpen = true;
          }
        }, (_err: any) => {
          const lang = localStorage.getItem('selectedLanguage');
          let msg = 'Unable to create the profile! Please try again or contact support.';
          if (lang === 'Korean') {
            msg = '프로필을 만들 수 없습니다! 다시 시도하거나 지원 부서에 문의하십시오.';
          }
          if (lang === 'Japanese') {
            msg = 'プロファイルを作成できません！再試行するか、サポートにお問い合わせください。';
          }
          this.popupMessageService.showError(msg, 'error');
        });
      }
    }
  }

  updateAdminProfile(taxInfoFlag: boolean) {
    LocalService.set('userProfile', { ...this.userProfile, ...this.adminInfoForm.value });
    this.userProfile = LocalService.get('userProfile');
    if (!taxInfoFlag) {
      if (this.userProfile.taxInfo) {
        this.userProfile.taxInfo.type === 'W9'
          ? this.router.navigate(['./tax-infow9'], { relativeTo: this.route })
          : this.router.navigate(['./tax-infot4'], { relativeTo: this.route });
      } else {
        const country = this.userProfile.country.toLowerCase();
        country === 'united states of america' || country === 'united states' || country === 'usa'
          ? this.router.navigate(['./tax-infow9'], { relativeTo: this.route })
          : this.router.navigate(['./tax-infot4'], { relativeTo: this.route });
      }
      return;
    }
    if (!this.userProfile.taxInfo && this.countryFlag
      && !this.isTaxFormMandate && (this.updateTaxUsers.indexOf(this.userProfile.username) > -1)) {
      const country = this.userProfile.country.toLowerCase();
      if (country === 'united states of america' || country === 'united states' || country === 'usa') {
        this.usaFormModalOpen = true;
      }
      if (country === 'canada') {
        this.canadaFormModalOpen = true;
      }
      return;
    } else {
      this.disableButton = true;
      delete this.userProfile.profilePicUrl;
      LocalService.set('userProfile', this.userProfile);
      this.userProfile.programAdministrators = this.userProfile.programAdministrators.map((item: any) => item.username);
      this.userProfile.programSalesManagers = this.userProfile.programSalesManagers.map((item: any) => item.username);
      this.userProfile.programSEManagers = this.userProfile.programSEManagers.map((item: any) => item.username);
      const countryNames = this.userProfile.salesCountry.split(',');
      this.userProfile.salesCountry = countryNames.map((item: any) => item.trim());
      if (this.userProfile.id) {
        this.profileService.updateProfile(this.userProfile).subscribe((data: any) => {
          LocalService.set('userProfile', data);
          this.userProfile = LocalService.get('userProfile');
          this.storeService.updateRole.next(true);
          this.updateModalOpen = true;
        }, (_err: any) => { });
      } else {
        this.profileService.postProfile(this.userProfile).subscribe((data: any) => {
          LocalService.set('userProfile', data);
          this.userProfile = LocalService.get('userProfile');
          if (this.currentPic) {
            this.profileService.postProfilePic(this.currentPic, this.userProfile.id)
              .subscribe((pic: any) => {
                this.disableButton = false;
                this.userProfile.profilePicUrl = pic.profilePicUrl;
                LocalService.set('userProfile', this.userProfile);
                this.createModalOpen = true;
              }, (_err: any) => { });
          } else {
            this.createModalOpen = true;
          }
        }, (_err: any) => {
          const lang = localStorage.getItem('selectedLanguage');
          let msg = 'Unable to create the profile! Please try again or contact support.';
          if (lang === 'Korean') {
            msg = '프로필을 만들 수 없습니다! 다시 시도하거나 지원 부서에 문의하십시오.';
          }
          if (lang === 'Japanese') {
            msg = 'プロファイルを作成できません！再試行するか、サポートにお問い合わせください。';
          }
          this.popupMessageService.showError(msg, 'error');
        });
      }
    }
  }

  checkSelected(allRole: any, selectedRole: any) {
    return allRole.id === selectedRole.id;
  }

  partnerSelfService() {
    window.open(this.selfServiceUrl, '_blank');
  }

  openPdf() {
    window.open('https://sellerrewards-datahandler.cisco.com/shared/files/seller-rewards.pdf', '_blank');
  }

  onPamFormSubmit() {
    if (!this.pamAgreeFlag) { return; }
    const reqParam = {
      firstName: this.userProfile.firstName,
      lastName: this.userProfile.lastName,
      primaryEmail: this.userProfile.primaryEmail,
      username: this.userProfile.username,
    };
    this.profileService.updatePamProfile(reqParam).subscribe((res: any) => {
      const msg = 'Profile created successfully ';
      this.popupMessageService.showSuccess(msg, 'success', 'pamCreateProfileFormSubmission');
      if (res.active && res.userType === 'PAM') {
        const pamRes: any = res;
        const savedBeGeoIds = res['pamDefaultSelection']['beGeoIds'];
        const savedFirst = savedBeGeoIds.length > 0 ? savedBeGeoIds[0] : null;
        if (savedFirst) {
          pamRes.company['id'] = savedFirst.companyId;
          pamRes['company']['region'] = savedFirst.region;
        }
        res.pampopup = true;
        this.storeService.setUserObj(res);
        LocalService.set('userProfile', pamRes);
        return this.router.navigateByUrl('/home/manager/manage-challenges');
      }
    }, (_error: any) => { });
  }

  getRegionList() {
    this.dashboardService.getRegionList(this.userProfile.username).subscribe((data: any) => {
      this.regionsList = data.theaters.map((theater: string) => ({ name: theater }));
      this.pamUserForm.patchValue({ partnerTheatre: data.theaters[0] });
      this.getCountryList('Rdata');
    });
  }

  getCountryList(val?: any) {
    this.dashboardService
      .getCountryListRequest(this.userProfile.username, this.pamUserForm.value.partnerTheatre)
      .subscribe((data: any) => {
        this.options = data['countryGroups'];
        this.countryItems = this.options.map((country: string) => ({ name: country }));
        if (val === 'Rdata') {
          this.pamUserForm.patchValue({ partnerCountry: this.options[0] });
          this.onChangeCountry(this.options[0], 'CData');
        }
      });
  }

  onChangeCountry(value: any, val?: any) {
    this.getPrMgrnm();
    this.currentCountryForBeGeo = value;
    this.beGeoPage = 0;
    this.beGeoTotalElements = 0;
    this.beGeoIDoptions = [];
    this.beGeoItems = [];
    this.fetchBeGeoItems(val);
  }

  private fetchBeGeoItems(val?: string, append: boolean = false): void {
    if (this.beGeoLoading) { return; }
    this.beGeoLoading = true;
    const paramReq: any = { username: this.userProfile.username, countries: [this.currentCountryForBeGeo] };
    this.dashboardService.getBeGeoIdsRequest(paramReq, undefined, 10, this.beGeoPage).subscribe((data: any) => {
      this.beGeoTotalElements = data.totalElements || 0;
      const items = data.content || [];
      this.beGeoIDoptions = append ? this.beGeoIDoptions.concat(items) : items;
      this.beGeoItems = this.beGeoIDoptions;
      this.beGeoLoading = false;
      if (val === 'CData' && this.beGeoIDoptions.length > 0) {
        this.pamUserForm.patchValue({ partnerBeGeo: this.beGeoIDoptions[0].partnerNameBegeoId });
      } else if (!append) {
        this.pamUserForm.patchValue({ partnerBeGeo: '' });
      }
    }, () => {
      this.beGeoLoading = false;
    });
  }

  onBeGeoScrollEnd(): void {
    if (this.beGeoLoading || this.beGeoIDoptions.length >= this.beGeoTotalElements) { return; }
    this.beGeoPage++;
    this.fetchBeGeoItems(undefined, true);
  }

  getPrMgrnm() {
    const theatre = this.pamUserForm.value.partnerTheatre as string;
    const country = this.pamUserForm.value.partnerCountry as string;
    const managerConfig = this.programManagerConfig[theatre] || this.programManagerConfig.default;
    if (typeof managerConfig === 'string') {
      this.progmMgrNm = managerConfig;
    } else {
      this.progmMgrNm = managerConfig[country] || managerConfig.default;
    }
  }
}
